import type { EmployeeDesignation, ExecutiveBriefingProfile } from '../types';
import { hasOfficeOpsPrivileges, isCooDesignation } from './employeeDesignations';

/** Admins, project managers, EAs, and office managers may open Project P&L (nav + page). */
export function canAccessProjectPL(args: {
  authRole: string | undefined;
  designations: EmployeeDesignation[] | string[] | undefined;
}): boolean {
  if (args.authRole === 'admin' || args.authRole === 'cpa') return true;
  const d = args.designations;
  if (!d?.length) return false;
  return d.includes('project_manager') || hasOfficeOpsPrivileges(d);
}

/**
 * Who maps and approves 1099 designer invoices (and the job POs those
 * approvals issue). Finance + office ops — not the COO, even if they are also a PM.
 */
export function canReviewDesignerInvoices(args: {
  authRole: string | undefined;
  designations?: EmployeeDesignation[] | string[] | undefined;
  briefingProfile?: ExecutiveBriefingProfile | null;
}): boolean {
  if (args.authRole === 'cpa') return false;
  if (isCooDesignation({
    designations: args.designations,
    briefingProfile: args.briefingProfile,
  })) {
    return false;
  }
  if (args.authRole === 'admin') return true;
  const d = args.designations;
  if (!d?.length) return false;
  return d.includes('cfo') || d.includes('project_manager') || hasOfficeOpsPrivileges(d);
}
